import * as React from 'react';
import { useEffect } from 'react';

import { useHideTsmPointsNotificationLoyaltyBannerExperiment } from 'experiments/hide-tsm-pointsnotification-loyaltybanner/use-enable-item-detail-reorder-experiment';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useStoreContext } from 'state/store';
import { useUIContext } from 'state/ui';

import { useTopServiceModeDetails } from './hooks/use-top-service-details';
import { TopServiceModeView } from './top-service-mode.view';

/**
 *
 * TopServiceMode purpose
 *
 */
export const TopServiceMode = () => {
  const enableOrdering = useFlag(LaunchDarklyFlag.ENABLE_ORDERING);
  const { resetStore, store } = useStoreContext();
  const { setShouldShowPreConfirmCurbsideModal } = useUIContext();
  const topServiceModeDetails = useTopServiceModeDetails();
  const hideTsmOnHome = useHideTsmPointsNotificationLoyaltyBannerExperiment();

  useEffect(() => {
    if (!enableOrdering) {
      resetStore();
    }
  }, [enableOrdering, store]);

  if (hideTsmOnHome) {
    return null;
  }

  return (
    <TopServiceModeView
      {...topServiceModeDetails}
      openModal={() => setShouldShowPreConfirmCurbsideModal(true)}
    />
  );
};
